import { FieldInputType } from 'constants/fields';
import { formatNumberToCurrencyString } from 'utils/number';

import { DataDisplayVariant } from './DataDisplay.constants';

export const getCardValueVariant = variant => {
  switch (variant) {
    case DataDisplayVariant.STYLE_B:
      return 'bold20';

    case DataDisplayVariant.STYLE_C:
      return 'bold40';

    case DataDisplayVariant.STYLE_E:
      return 'medium14';

    default:
      return 'bold16';
  }
};

export const getCardTitleVariant = variant => {
  switch (variant) {
    case DataDisplayVariant.STYLE_C:
      return 'regular16';

    case DataDisplayVariant.STYLE_E:
      return 'regular12';

    default:
      return 'regular14';
  }
};

export const getFormattedValue = (value, type) => {
  if (!type) {
    return value;
  }

  switch (type) {
    case FieldInputType.CURRENCY:
      return formatNumberToCurrencyString(value, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

    default:
      return value;
  }
};
